import { menuTabSet } from "./menuTabSet";

// please align with existing page
export const pageSet = {
  // menuTab: refer to menuTab set
  ...menuTabSet,
  HORSE_PROFILE: "horseprofile",
  SIMULCAST_CALENDAR: "simulcast_calendar",
  SIMULCAST_FIXTURE: "simulcast_fixture",
  CARNIVAL: "carnival",
  SHAREVIEW: "shareview",
}